var aspiraFontStr = '"Aspira Webfont", "Helvetica", "Arial", sans-serif';
export default {
  aspira: aspiraFontStr,
  "default": aspiraFontStr
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/fontFamily/index.js
// module id = 1034
// module chunks = 12